import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { Container as ContainerCount } from '@/main/components/shared/countControl/styles';
import { RowFlex } from '@/main/components/shared/styles';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0.6rem;
  &:not(:nth-child(2)) {
    border-top: 1px solid #ccc;
  }

  > img {
    width: 100%;
    max-width: 100px;
    max-height: 100px;
    min-width: 100px;
    min-height: 100px;
    object-fit: contain;
  }

  .supplierInventoryPartName,
  .supplierInventoryPartTitle {
    > span {
      word-break: break-all;
      white-space: normal;
    }
  }
`;

export const IconButtonClose = styled(IconButton)`
  &&& {
    position: absolute;
    top: 0.6rem;
    right: 5px;
  }
`;
export const AreaInfo = styled.div`
  padding-left: 0.6rem;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  .supplierInventoryPartTitle {
    font-weight: normal;
  }
`;
export const TitleProduct = styled.p`
  margin: 0 0 0.4rem 0;
  padding-right: 15px;

  > span {
    font-weight: bold;
  }
`;
export const TextProduct = styled.p`
  margin: 0 0 0.4rem 0;
`;
export const AreaPrice = styled.div`
  > p {
    margin: 0;
  }
`;

export const CustomRowFlex = styled(RowFlex)<{ showPrices: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ showPrices }) =>
    showPrices ? 'space-between' : 'flex-end'};
  align-items: flex-start;
  width: 100%;
  margin-top: 10px;

  > ${TextProduct} {
    width: 50%;
  }

  > ${ContainerCount} {
    width: 50%;
    max-width: 100px;
  }
`;

